















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Outairequipment from "../../../store/entities/outair_equipment";
@Component
export default class CreatOutairequipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  outairequipment: Outairequipment = new Outairequipment();
  idisable:boolean=false;
  selwarehouselist = [];
  selfloorlist = [];
  created() {
  }
  gflist=[];
  seltime=[
    {value: 1,label: '1分钟'},
    {value: 5,label: '5分钟'},
    {value: 10,label: '10分钟'},
    {value: 15,label: '15分钟'},
    {value: 30,label: '30分钟'},
    {value: 60,label: '60分钟'},
    {value: 120,label: '120分钟'},
    {value: 240,label: '240分钟'},
    {value: 360,label: '360分钟'},
    {value: 720,label: '720分钟'},
    {value: 1440,label: '1440分钟'},
  ]
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  get outair_threshold(){
    return this.$store.state.outair_threshold.list;
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  get gwequipment() {
    return this.$store.state.gwequipment.list;
  }

  selfactory(value:Number){
    this.outairequipment.ftId = value;
    if(value !=0 && value != undefined){
      this.getselwarehouse();
    }
  }
  selwarehouse(value:Number){
    this.outairequipment.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.outairequipment.fId = 0;
      this.selfloorlist = [];
    }
    // this.getfloor();
  }
  selfloor(value:Number){
    this.outairequipment.fId = value;
  }
   async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.outairequipment,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.outairequipment,
    });
  }
  save() {
    (this.$refs.outairequipmentForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "outair_equipment/create",
          data: this.outairequipment,
        });
        (this.$refs.outairequipmentForm as any).resetFields();
        this.$emit("save-success");
        setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
       this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.outairequipmentForm as any).resetFields();
    this.$emit("input", false);
    this.$emit("Radio",false);
    this.selwarehouselist = [];
    this.selfloorlist = [];
  }
  outairequipmentRule = {
    ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    snid: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    tId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
    acquisitionInterval: [{type:"number", required: true, message: "请选择采集间隔", trigger: "change" }],
  };
}
